// STC (Section 232) Process Key Constant
export const STC_PROCESS_KEY = 'SHIPMENT_STC_PROCESS'

// STC (Section 232) State Constants
export const STC_STATES = {
  NONE: 'STATE_STC_NONE',
  IN_PROCESS: 'STATE_STC_IN_PROCESS',
  IN_READY: 'STATE_STC_READY',  // Backend returns STATE_STC_READY
  COMPLETED: 'STATE_STC_COMPLETED',
  FAILED: 'STATE_STC_FAILED'
}

// STC Workflow Event Constants
export const STC_EVENTS = {
  EXCEL_FOR_PDF_INV: 'EXCEL_FOR_PDF_INV',
  OUTBOUND_DISPATCH_REQUEST: 'OUTBOUND_DISPATCH_REQUEST'
}

// STC Button Constants (key and label)
export const STC_BUTTONS = {
  APPLY_232: {
    key: 'APPLY_232',
    label: 'APPLY 232',
    labelLoading: 'APPLYING 232...'
  },
  RESET: {
    key: 'RESET_STC',
    label: 'RESET'
  },
  FINAL_REVIEW_STC: {
    key: 'FINAL_REVIEW_STC',
    label: 'FINAL REVIEW'
  },
  SEND_STC: {
    key: 'SEND_STC',
    label: 'SEND',
    labelLoading: 'SENDING...'
  },
  UPDATE: {
    key: 'UPDATE_STC',
    label: 'UPDATE'
  },
  RETURN_TO_EDIT: {
    key: 'RETURN_TO_EDIT_STC',
    label: 'RETURN TO EDIT'
  }
}

// STC Toast Messages
export const STC_MESSAGES = {
  RESET_SUCCESS: 'STC reset successfully',
  RESET_ERROR: 'Failed to reset STC',
  SEND_SUCCESS: 'STC document sent to customer successfully',
  SEND_ERROR: 'Failed to send STC document to customer'
}

// STC State Arrays for conditions
export const STC_STATE_ARRAYS = {
  EDITABLE_STATES: [STC_STATES.IN_PROCESS, STC_STATES.IN_READY],
  APPLY_232_STATES: [STC_STATES.NONE, STC_STATES.IN_PROCESS],
  FINAL_REVIEW_STATES: [STC_STATES.IN_PROCESS,STC_STATES.IN_READY,],
  SEND_BUTTON_STATES: [STC_STATES.IN_READY],
  RESET_UPDATE_STATES: [STC_STATES.FAILED, STC_STATES.COMPLETED],
  INACTIVE_STATES: [STC_STATES.NONE, STC_STATES.COMPLETED],
  START_JOB_STATES: [STC_STATES.NONE],
  BACK_TO_POOL_STATES: [STC_STATES.IN_PROCESS, STC_STATES.IN_READY]
}

// BH House States for STC workflow
export const BH_HOUSE_STATES = {
  ASSIGNED: 'STATE_BH_ASSIGNED',
  BROKER_ASSIGNED: 'STATE_BH_BROKER_ASSIGNED',
  BROKER_IN_PROCESS: 'STATE_BH_BROKER_IN_PROCESS'
}

// STC Workflow Target States
export const STC_TARGET_STATES = {
  IN_READY: 'STC_READY',
  COMPLETED: 'STC_COMPLETED',
  FAILED: 'STC_FAILED',
  RESET: 'STC_IN_PROCESS'
}

// BH House Workflow Target States
export const BH_TARGET_STATES = {
  BROKER_IN_PROCESS: 'BH_BROKER_IN_PROCESS'
}

// STC State Labels for display
export const STC_STATE_LABELS = {
  [STC_STATES.NONE]: 'STC PENDING',
  [STC_STATES.IN_PROCESS]: 'STC IN PROCESS',
  [STC_STATES.IN_READY]: 'STC READY',  // Matches STATE_STC_READY
  [STC_STATES.COMPLETED]: 'STC COMPLETED',
  [STC_STATES.FAILED]: 'STC FAILED'
}

// STC State Colors for display
export const STC_STATE_COLORS = {
  [STC_STATES.FAILED]: '#dc3545',
  [STC_STATES.COMPLETED]: '#28a745',
  default: '#007bff'
}

// Additional STC Button Constants
export const STC_BUTTONS_EXTENDED = {
  START_JOB: {
    key: 'start-job',
    label: 'START JOB',
    labelLoading: ' LOADING...'
  },
  BACK_TO_POOL: {
    key: 'BACK_TO_POOL',
    label: 'BACK TO POOL',
    labelLoading: ' LOADING...'
  },
  TAKE_OVER: {
    key: 'TAKE_OVER',
    label: 'TAKE OVER',
    labelLoading: ' LOADING...'
  }
}
